import React, { useCallback } from 'react';

import { Scroll, Stack } from '@/components/layout';
import { withActivePlayer, WithActivePlayerInjectedProps } from '@/hocs/with-active-player';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { RefreshControl, StyleSheet } from 'react-native';
import { PlayerProfile } from '../components/player-profile-content';

function PlayerProfileScreenBase({
  profile,
  saveNote,
  refetch,
  isRefetching,
}: WithActivePlayerInjectedProps) {
  const styles = useStyles();
  const { scale, isTablet } = useScaling();
  const onRefresh = useCallback(async () => {
    await refetch();
  }, [refetch]);

  return (
    <Stack flex={1} backgroundColor={colors['2']}>
      <PlayerProfile profile={profile} saveNote={saveNote}>
        <PlayerProfile.Header />
        {isTablet ? (
          <Stack direction="row" flex={1} style={styles.landscapeContainer}>
            <Stack style={[styles.leftPane, { width: scale(375) }]}>
              <Scroll
                style={styles.leftPaneScroll}
                contentContainerStyle={styles.leftPaneScrollContent}
                refreshControl={<RefreshControl refreshing={false} onRefresh={onRefresh} />}
                showsVerticalScrollIndicator={false}>
                <PlayerProfile.Top />
                <PlayerProfile.Content forceTab="overview" />
              </Scroll>
            </Stack>
            <Stack flex={1} style={styles.rightPane}>
              <PlayerProfile.Tab excludeOverview />
              <Scroll
                style={styles.rightPaneScroll}
                contentContainerStyle={styles.rightPaneScrollContent}
                refreshControl={<RefreshControl refreshing={false} onRefresh={onRefresh} />}
                showsVerticalScrollIndicator={false}>
                <PlayerProfile.Content />
              </Scroll>
            </Stack>
          </Stack>
        ) : (
          <Scroll
            style={styles.mobileScroll}
            contentContainerStyle={styles.mobileScrollContent}
            stickyHeaderIndices={[1]}
            refreshControl={<RefreshControl refreshing={isRefetching} onRefresh={onRefresh} />}
            showsVerticalScrollIndicator={false}>
            <PlayerProfile.Top />
            <PlayerProfile.Tab />
            <Stack>
              <PlayerProfile.Content />
            </Stack>
          </Scroll>
        )}
      </PlayerProfile>
    </Stack>
  );
}

export const PlayerProfileScreen = withActivePlayer(PlayerProfileScreenBase);

const useStyles = createStyles(({ scale }) => ({
  landscapeContainer: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: colors['10'],
  },
  leftPane: {
    flexShrink: 0,
    backgroundColor: 'white',
  },
  leftPaneScroll: {
    flex: 1,
  },
  leftPaneScrollContent: {
    flexGrow: 1,
    paddingBottom: scale({ phone: 0, tablet: 100 }),
  },
  mobileScroll: {
    flex: 1,
  },
  mobileScrollContent: {
    flexGrow: 1,
    paddingBottom: scale(100),
  },
  rightPane: {
    backgroundColor: colors['1'],
  },
  rightPaneScroll: {
    flex: 1,
  },
  rightPaneScrollContent: {
    flexGrow: 1,
    paddingBottom: scale(100),
  },
}));
